<div class="block administrator" *ngIf="aboutHTML.administrator">
  <h4 i18n>Who we are</h4>
  <div class="text-content" [innerHTML]="aboutHTML.administrator"></div>
</div>

<div class="block creation-reason" *ngIf="aboutHTML.creationReason">
  <h4 i18n>Why we created {{ instanceName }}</h4>
  <div class="text-content" [innerHTML]="aboutHTML.creationReason"></div>
</div>

<div class="block maintenance-lifetime" *ngIf="aboutHTML.maintenanceLifetime">
  <h4 i18n>How long we plan to maintain {{ instanceName }}</h4>
  <div [innerHTML]="aboutHTML.maintenanceLifetime"></div>
</div>

<div class="block business-model" *ngIf="aboutHTML.businessModel">
  <h4 i18n>How we will pay for keeping {{ instanceName }} running</h4>
  <div class="text-content" [innerHTML]="aboutHTML.businessModel"></div>
</div>
